module.exports = __webpack_public_path__ + "static/media/rhythm_logo_white.d7e19b41.svg";